import type { Msg } from "../message";
import type { Model } from "../model";
import type { View } from "../types";
import type { RenderNode } from "../ui";

export const create = (): View<Model, Msg, RenderNode> => {
    let uninitialised = true;
    return (_model: Model, _raise: (msg: Msg) => void): RenderNode[] => {
        if (uninitialised) {
            init();
            uninitialised = false;
        }
        return [];
    };
};

function init(): void {
    const dropdowns = document.getElementsByClassName("dropdown");
    for (const dropdown of dropdowns) {
        const menuItem = dropdown.querySelector(".menu");
        if (menuItem) {
            menuItem.addEventListener("click", onMenuClick);
        }
    }

    // close open menu when document is clicked outside
    document.addEventListener("mouseup", (event: MouseEvent) => {
        const targetElement = <Element>event.target;
        if (targetElement.closest(".dropdown-content") === null && targetElement.closest(".menu") === null) {
            const contentElements = document.getElementsByClassName("dropdown-content");
            for (const contentElement of contentElements) {
                if (contentElement.classList.contains("dropdown-content-visible")) {
                    contentElement.classList.remove("dropdown-content-visible");
                }
            }
        }
    });
}

function onMenuClick(event: Event): void {
    const menuElement = <Element>event.currentTarget;
    const currentContentElement = menuElement.parentElement!.querySelector(".dropdown-content");

    const contentElements = document.getElementsByClassName("dropdown-content");
    for (const contentElement of contentElements) {
        if (contentElement === currentContentElement) {
            currentContentElement!.classList.toggle("dropdown-content-visible");
        } else {
            contentElement.classList.remove("dropdown-content-visible");
        }
    }
}
